<template>
  <div id="app">
    <keep-alive :exclude="['giftList']">
        <router-view ></router-view>
    </keep-alive>
  </div>
</template>
<script>
import * as util from './assets/js/utils';
export default {
    name: 'view_app_main',
    components: {},
    data() {
        return {};
    },
    created() {
        // this.getToken();
        // util.WeiXinShare();
    },
    methods: {
    // 判断登录态
        async getToken() {
            let { Result, Content } = await this.$http.login({});
            console.log(Result, Content);
            if (Result === 200) {
                this.login = true;
            }
        }
    }
};
</script>

<style lang="less">
@import '../../assets/less/mixins.less';
#app {
  .setSize(100%, 100%);
   -webkit-overflow-scrolling: touch;
}
</style>

